import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';

import HeightSetter from './HeightSetter';

export default class SmoothHeightChanger extends PureComponent {
  static propTypes = {
    /** Ключ, при изменении которого необходимо пересчитать высоту */
    updateHeightKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /** Высота свёрнутого контейнера */
    collapsedHeight: PropTypes.number,
  };

  state = {
    // Высота текста для задания блоку, для плавной смены высоты
    height: null,
  };

  componentDidMount() {
    if (this.props.children) this.syncHeightWithDOM();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.updateHeightKey !== this.props.updateHeightKey) {
      this.syncHeightWithDOM();
    }
  }

  syncHeightWithDOM = () => this.setState({ height: this.containerRef?.current?.offsetHeight });

  containerRef = createRef();

  render() {
    const {
      children,
      ...otherProps
    } = this.props;

    const {
      height,
    } = this.state;

    return (
      <HeightSetter
        wrapperRef={this.containerRef}
        heightValue={height}
        {...otherProps}
      >
        {children}
      </HeightSetter>
    );
  }
}
